import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import API from "../services/api";
import "./SearchPage.css";

function SearchPage() {

  const location = useLocation();
  const navigate = useNavigate();

  const [data, setData] = useState({
    exact: [],
    similar: [],
    category: []
  })

  const query = new URLSearchParams(location.search).get("q")

  useEffect(() => {

    if (!query || query.trim() === "") return;

    const fetchProducts = async () => {
      try {
        const res = await API.get(
          `/api/products/smart-search?keyword=${encodeURIComponent(query)}`
        );
        setData(res.data);
      } catch (error) {
        console.log(error);
      }
    };

    fetchProducts();
  }, [query]);

  const ProductRow = ({ p }) => (
  <div
    className="product-row"
    onClick={() => navigate(`/product/${p.id}`)}
  >
    <div className="product-img">
      <img src={p.imageUrl} alt={p.name} />
    </div>

    <div className="product-details">

      <h3>{p.name}</h3>

      <div className="product-rating-row">
        <span className="rating-badge">⭐ 4.5</span>
        <span className="rating-count">(1,287)</span>
      </div>

      <div className="price-mobile">
        ₹{p.price}
      </div>

      <div className="delivery-info">
        🚚 Delivery in 2 days
      </div>

      <h6>{p.description}</h6>

      <ul>
        {p.features?.slice(0, 6)?.map((f, i) => (
          <li key={i}>{f}</li>
        ))}
      </ul>

    </div>

    <div className="product-price">
      <b>₹{p.price}</b>

      <span className="delivery-right">
        🚚 Delivery in 2 days
      </span>
    </div>
  </div>
);

  return (
    <div className="search-page">

      {data.exact.length > 0 && (
        <>
          <h2>Top Result</h2>
          {data.exact.map(p => (
            <ProductRow key={p.id} p={p} />
          ))}
        </>
      )}

      {data.similar.length > 0 && (
        <>
          <h2>Similar Products</h2>
          {data.similar.map(p => (
            <ProductRow key={p.id} p={p} />
          ))}
        </>
      )}

      {data.category.length > 0 && (
        <>
          <h2>Other Products</h2>
          {data.category.map(p => (
            <ProductRow key={p.id} p={p} />
          ))}
        </>
      )}

    </div>
  )

}

export default SearchPage;